import {decorate, injectable} from "inversify";
import {Action} from "@dp-instant/core";
import {PlayerPrefs} from "../ported/Utils/Unity/PlayerPrefs";
import {di} from "@dp-instant/core";
import {TypesSocial} from "@dp-instant/interfaces";
import {Core} from "../ported/Base/Core";

export class MainActionHomeEvolution extends Action {
    async execute() {
        await PlayerPrefs.Load();

        //Try to save player prefs
        //Todo move it to separate action if it will be worked correctly
        window.addEventListener("unload", function () {
            const STORAGE_KEY = "homo-evolution-player-data";
            const cookie = di.get(TypesSocial.cookie);
            const data = Core.Player.toJSON();
            cookie.save(STORAGE_KEY, data);
            cookie.write();
        });

        window.appPIXI.run();
        console.log("Application is running");
    }
}

decorate(injectable(), MainActionHomeEvolution);
